// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".complete[data-v-07472338]{color:#63ba3b!important}", ""]);
// Exports
module.exports = exports;
